'use strict';

module.exports = require('./es6/crc81wire').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc8_1wire.js
// module id = 766
// module chunks = 0